
import { Parallax } from 'react-parallax';
import { HashLink } from "react-router-hash-link";
import ImageGallery from 'react-image-gallery';

import "react-image-gallery/styles/css/image-gallery.css"; //this is required by gallery

export default function AboutSierra() {
  const photosIndices = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  let images = [];
  for (let i in photosIndices) {
    images.push({
      original: `photos/sierra/${photosIndices[i]}.jpg`,
      thumbnail: `photos/sierra/small${photosIndices[i]}.jpg`
    })
  }

  return (
    <div>

      <Parallax strength={300} bgImage="photos/sierra/4.jpg">
        <div className="section no-pad-bot">

          <div className="container ">
            <h1 className="header center text-lighten-2">Sierra</h1>
            <div className="row">
              <div className="col l6 s12 dark-bg right">
                <p>Sierra pas mus atkeliavo iš Serbijos veislyno Invictus Boston. Vadoje buvo 4
                  šuniukai (dvi kalytės ir du patinėliai). Vos paaugus šuniukams veislynas informavo, jog mūsų išsirinkta
                  kalytė yra ypatingai meili, mėgsta dėmesį, mėgsta būti glostoma, visada išsireikalauja būti paimta ant
                  rankų. Patys važiavome jos pasiimti į Serbiją. Kelionė namo užtruko dvi dienas. Kelionės metu Sierra
                  buvo tikra šaunuolė, nekėlė jokių rūpesčių, kantriai laukė kol pasieksime namus, nors matėme, jog
                  kelionė jai ne itin patinka. Tik grįžus namo buvo pirma pažintis su mūsų vaikais ir tas vaizdas tiesiog
                  pavergė visų širdis, Sierra pribėgo ir pradėjo iškart džiaugtis, žaisti, bėgioti aplinkui, atrodo lyg būtų
                  susitikimas su senai nematytais draugais, manau ji suprato, jog nuo šiol čia bus jos šeima ir namai.
                  Augant jos charakteris nesikeitė, išliko tokia pat meili, prieraiši. Mes net sakome, jog ji puikiai galėtų
                  būti terapijos šuo, jos meilė tiesiog liejasi per kraštus ir užtektų visiems. Nei karto nepastebėjome
                  agresyvaus elgesio, tai yra labiau „nusileidžiantis“ šuo, prisitaikantis, tikra gerietė! Sierra taip pat
                  mėgsta žaisti lauke kartu su kitomis mūsų kaltytėmis, bet jei tik oras idealus, priešingu atveju jai labiau
                  priimtinos pramogos namuose, tad šiuo požiūriu ji labiau „miestietė“, ko negalime pasakyti apie kitas
                  mūsų kalytes.
                </p>
                <p>Kaip mama Sierra yra labai tvarkinga ir švari, dažnai prausia savo šuniukus, puikiai jais rūpinasi, šioje
                  vietoje rūpesčių mums jokių nėra.
                </p>
                <p>Sierrai reguliariai daromi med. tyrimai, papildomai atliktas akių kataraktos genetinis testas galimam
                  paveldimumui nustatyti, blogų genų nėra.
                </p>
                <p>Dėl būsimų šuniukų vados prašau <HashLink to="#kontaktai">susisiekite su mumis.</HashLink></p>
              </div>
            </div>
          </div>
        </div>
      </Parallax>

      <div className="container">
        <div className="row center">
          <h2>Sierros galerija</h2>
        </div>
        <div className="row center">
          <ImageGallery items={images} slideInterval={2000} />
        </div>
        <a href="/docs/sierra.pdf" target="_blank" rel="noopener noreferrer">Kilmės dokumentas.</a>
      </div>

    </div>
  );

}
